export default __webpack_public_path__ + "static/media/general-template1.03c00d58.jpg";